import { render, staticRenderFns } from "./TeamEdit.vue?vue&type=template&id=0c0a81bf&scoped=true"
import script from "./TeamEdit.vue?vue&type=script&lang=js"
export * from "./TeamEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0a81bf",
  null
  
)

export default component.exports